import { Col, Container, Row } from "react-bootstrap";
import { AuthLayoutModel } from "./authLayoutModel";
import { AuthHeader } from "../authHeader/authHeader";
import tiresImage from "./images/dbh_warehouse.jpg";
import { Toaster } from "sonner";

export function AuthLayout({ children }: AuthLayoutModel) {
  return (
    <div className="auth-layout">
      <AuthHeader />
      <Container fluid className="auth-layout-container">
        <Toaster position="top-center" richColors />
        <Row className="h-100">
          <Col lg="7" className="d-none d-lg-block">
            <div className="auth-layout-image-wrapper">
              <img src={tiresImage} alt="car" className="auth-layout-image" />
            </div>
          </Col>
          <Col lg="5">
            <div className="auth-layout-form-wrapper">{children}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
